/* ============================================================
   HYDRUS TECH — Built Different 4-tab section controller
   Singleton-guarded per AI Training Journal §1.16. Document-level
   delegation per §1.5. Reads per-section state from
   window._hydrusTech_<section.id> blobs emitted by the section.

   Behavior:
   - Tab click / dot click: switch active tab + active panel.
   - IntersectionObserver per section: when the section enters
     the viewport (50% visible), play the active panel's video.
     When it leaves, pause all videos in the section.
   - Tab switch while section is in view: pause all videos, then
     play the new active panel's video.
   - Videos use preload="none" + lazy <source>; they don't fetch
     until JS calls play(), keeping page weight low when the
     visitor scrolls past without engaging.
   ============================================================ */
(function () {
  if (window.HydrusTech) return;
  window.HydrusTech = true;

  var PREFIX = '_hydrusTech_';

  function getSectionEl(sectionId) {
    return document.querySelector('.ht-section[data-section-id="' + sectionId + '"]');
  }

  function setActiveIndex(sectionEl, index) {
    var tabs = sectionEl.querySelectorAll('.ht-tab');
    var panels = sectionEl.querySelectorAll('.ht-panel');
    var dots = sectionEl.querySelectorAll('.ht-dot');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.toggle('active', i === index);
    }
    for (var p = 0; p < panels.length; p++) {
      panels[p].classList.toggle('active', p === index);
    }
    for (var d = 0; d < dots.length; d++) {
      dots[d].classList.toggle('active', d === index);
    }
    pauseAllVideos(sectionEl);
    if (sectionEl.dataset.inView === '1') {
      playActiveVideo(sectionEl);
    }
  }

  function pauseAllVideos(sectionEl) {
    var videos = sectionEl.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      try { videos[i].pause(); } catch (e) { /* ignore */ }
    }
  }

  function playActiveVideo(sectionEl) {
    var activePanel = sectionEl.querySelector('.ht-panel.active');
    if (!activePanel) return;
    var video = activePanel.querySelector('video');
    if (!video) return;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () { /* autoplay blocked, ignore */ });
    }
  }

  function getIndexFromTarget(target) {
    var attr = target.dataset.tab || target.dataset.dot;
    if (attr === undefined) return -1;
    var n = parseInt(attr, 10);
    return isNaN(n) ? -1 : n;
  }

  /* Document-level click delegation — survives any section re-render */
  document.addEventListener('click', function (e) {
    var target = e.target;
    while (target && target !== document) {
      if (target.classList && (target.classList.contains('ht-tab') || target.classList.contains('ht-dot'))) {
        var sectionEl = target.closest('.ht-section');
        if (!sectionEl) return;
        var index = getIndexFromTarget(target);
        if (index < 0) return;
        setActiveIndex(sectionEl, index);
        return;
      }
      target = target.parentNode;
    }
  });

  /* Per-section IntersectionObserver — autoplay active panel video
     when section enters viewport, pause when it leaves. */
  function initSection(sectionId) {
    var sectionEl = getSectionEl(sectionId);
    if (!sectionEl) return;
    if (sectionEl.dataset.htInit === '1') return;
    sectionEl.dataset.htInit = '1';

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sectionEl.dataset.inView = '1';
          playActiveVideo(sectionEl);
        } else {
          sectionEl.dataset.inView = '0';
          pauseAllVideos(sectionEl);
        }
      });
    }, { threshold: 0.4 });

    observer.observe(sectionEl);
  }

  function bootstrap() {
    Object.keys(window).forEach(function (key) {
      if (key.indexOf(PREFIX) !== 0) return;
      var sectionId = key.slice(PREFIX.length);
      initSection(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Re-bootstrap on shopify:section:load (theme editor live preview) */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.ht-section')) {
      bootstrap();
    }
  });
})();
